import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CollaborationReason} from './collaboration-reason.model';
import * as CollaborationReasonActions from './collaboration-reason.actions';

export const collaborationReasonsFeatureKey = 'collaborationReasons';

export interface State extends EntityState<CollaborationReason> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CollaborationReason> = createEntityAdapter<CollaborationReason>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CollaborationReasonActions.addCollaborationReason,
    (state, action) => adapter.addOne(action.collaborationReason, state)
  ),
  on(CollaborationReasonActions.upsertCollaborationReason,
    (state, action) => adapter.upsertOne(action.collaborationReason, state)
  ),
  on(CollaborationReasonActions.addCollaborationReasons,
    (state, action) => adapter.addMany(action.collaborationReasons, state)
  ),
  on(CollaborationReasonActions.upsertCollaborationReasons,
    (state, action) => adapter.upsertMany(action.collaborationReasons, state)
  ),
  on(CollaborationReasonActions.updateCollaborationReason,
    (state, action) => adapter.updateOne(action.collaborationReason, state)
  ),
  on(CollaborationReasonActions.updateCollaborationReasons,
    (state, action) => adapter.updateMany(action.collaborationReasons, state)
  ),
  on(CollaborationReasonActions.deleteCollaborationReason,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CollaborationReasonActions.deleteCollaborationReasons,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CollaborationReasonActions.loadCollaborationReasons,
    (state, action) => adapter.setAll(action.collaborationReasons, state)
  ),
  on(CollaborationReasonActions.clearCollaborationReasons,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
